export class ReceiptDetailsDto {
  total: number;
  vatRate: number;
  description: string;
  category: string;
}